import React, { useState } from 'react';
import { usePackages } from '../context/PackageContext';
import '../styles/Admin.css';

const Admin = () => {
  const {
    packages,
    categories,
    addPackage,
    updatePackage,
    deletePackage,
    toggleVisibility
  } = usePackages();

  const [isEditing, setIsEditing] = useState(false);
  const [currentPackage, setCurrentPackage] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    category: '',
    duration: '',
    description: '',
    image: '',
    link: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (isEditing && currentPackage) {
      updatePackage(currentPackage.id, formData);
      setIsEditing(false);
      setCurrentPackage(null);
    } else {
      addPackage(formData);
    }
    
    // Reset form
    setFormData({
      title: '',
      category: '',
      duration: '',
      description: '',
      image: '',
      link: ''
    });
  };

  const handleEdit = (pkg) => {
    setIsEditing(true);
    setCurrentPackage(pkg);
    setFormData({
      title: pkg.title,
      category: pkg.category,
      duration: pkg.duration,
      description: pkg.description,
      image: pkg.image,
      link: pkg.link
    });
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setCurrentPackage(null);
    setFormData({
      title: '',
      category: '',
      duration: '',
      description: '',
      image: '',
      link: ''
    });
  };

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this package?')) {
      deletePackage(id);
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-header">
        <h1>Admin Panel - Package Management</h1>
        <a href="/" className="btn-back">← Back to Home</a>
      </div>

      <div className="admin-container">
        {/* Add/Edit Package Form */}
        <div className="admin-form-section">
          <h2>{isEditing ? 'Edit Package' : 'Add New Package'}</h2>
          <form onSubmit={handleSubmit} className="package-form">
            <div className="form-group">
              <label htmlFor="title">Package Title *</label>
              <input
                type="text"
                id="title"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="category">Category *</label>
              <input
                type="text"
                id="category"
                name="category"
                value={formData.category}
                onChange={handleInputChange}
                placeholder="e.g., Popular, Nature, Beach"
                required
              />
              <small>Available categories: {categories.filter(c => c !== 'All').join(', ')}</small>
            </div>

            <div className="form-group">
              <label htmlFor="duration">Duration *</label>
              <input
                type="text"
                id="duration"
                name="duration"
                value={formData.duration}
                onChange={handleInputChange}
                placeholder="e.g., 5 Days / 4 Nights"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="description">Description *</label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                rows="4"
                required
              ></textarea>
            </div>

            <div className="form-group">
              <label htmlFor="image">Image Path *</label>
              <input
                type="text"
                id="image"
                name="image"
                value={formData.image}
                onChange={handleInputChange}
                placeholder="/assets/images/trips/..."
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="link">Details Link *</label>
              <input
                type="text"
                id="link"
                name="link"
                value={formData.link}
                onChange={handleInputChange}
                placeholder="/trip-details/..."
                required
              />
            </div>

            <div className="form-actions">
              <button type="submit" className="btn-submit">
                {isEditing ? 'Update Package' : 'Add Package'}
              </button>
              {isEditing && (
                <button type="button" className="btn-cancel" onClick={handleCancelEdit}>
                  Cancel
                </button>
              )}
            </div>
          </form>
        </div>

        {/* Packages List */}
        <div className="admin-list-section">
          <h2>All Packages ({packages.length})</h2>
          <div className="packages-list">
            {packages.map((pkg) => (
              <div key={pkg.id} className={`package-item ${!pkg.visible ? 'hidden' : ''}`}>
                <div className="package-item-info">
                  <img src={pkg.image} alt={pkg.title} className="package-thumbnail" />
                  <div className="package-details">
                    <h3>{pkg.title}</h3>
                    <p className="package-meta">
                      <span className="category-badge">{pkg.category}</span>
                      <span>{pkg.duration}</span>
                    </p>
                    <p className="package-desc">{pkg.description.substring(0, 100)}...</p>
                  </div>
                </div>
                <div className="package-actions">
                  <button
                    className={`btn-toggle ${pkg.visible ? 'visible' : 'hidden'}`}
                    onClick={() => toggleVisibility(pkg.id)}
                    title={pkg.visible ? 'Hide package' : 'Show package'}
                  >
                    <i className={`fas fa-eye${pkg.visible ? '' : '-slash'}`}></i>
                  </button>
                  <button
                    className="btn-edit"
                    onClick={() => handleEdit(pkg)}
                    title="Edit package"
                  >
                    <i className="fas fa-edit"></i>
                  </button>
                  <button
                    className="btn-delete"
                    onClick={() => handleDelete(pkg.id)}
                    title="Delete package"
                  >
                    <i className="fas fa-trash"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Admin;
